import { render, staticRenderFns } from "./onlineChat.vue?vue&type=template&id=260008c8&scoped=true&"
import script from "./onlineChat.vue?vue&type=script&lang=js&"
export * from "./onlineChat.vue?vue&type=script&lang=js&"
import style0 from "./onlineChat.vue?vue&type=style&index=0&id=260008c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260008c8",
  null
  
)

export default component.exports